<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import UserManager from '@/admin/UserManager.vue'
import { useIsAuthorized } from '@/misc/composables/useIsAuthorized'
import { RoleEnum } from '@/misc/permissions/permissionsHelper'

import AppSettingsManager from './AppSettingsManager.vue'
import ConnectorsManager from './ConnectorsManager.vue'

const store = useStore()

const tab = ref<'userManager' | 'settingManager' | 'sancareSettingManager' | 'connectorsManager'>('userManager')

const userRole = computed(() => store.state.login.userRole)

const canManageUsers = useIsAuthorized([RoleEnum.ROLE_USER_MANAGER, RoleEnum.ROLE_ADMIN_MANAGER], userRole)
const canManageSettings = useIsAuthorized([RoleEnum.ROLE_SETTING_UPDATER], userRole)
const canManageSancareSettings = useIsAuthorized([RoleEnum.ROLE_SANCARE_SETTING_UPDATER], userRole)
const canManageConnectors = useIsAuthorized([RoleEnum.ROLE_SANCARE_SETTING_UPDATER], userRole)

onMounted(() => {
  if (canManageUsers.value) {
    tab.value = 'userManager'
  } else if (canManageSettings.value) {
    tab.value = 'settingManager'
  }
})

</script>

<template>
  <div class="admin-page">
    <div class="container">
      <ul class="row g-0 nav nav-tabs">
        <li
          v-if="canManageUsers"
          class="col nav-item text-center home-list-tab"
        >
          <span
            :class="{ 'active': tab === 'userManager' }"
            class="nav-link"
            @click="tab = 'userManager'"
          >
            Utilisateurs
          </span>
        </li>
        <li
          v-if="canManageSettings"
          class="col nav-item text-center home-list-tab"
        >
          <span
            :class="{ 'active': tab === 'settingManager' }"
            class="nav-link"
            @click="tab = 'settingManager'"
          >
            Paramètres
          </span>
        </li>
        <li
          v-if="canManageSancareSettings"
          class="col nav-item text-center home-list-tab"
        >
          <span
            :class="{ 'active': tab === 'sancareSettingManager' }"
            class="nav-link"
            @click="tab = 'sancareSettingManager'"
          >
            Paramètres Administrateur
          </span>
        </li>
        <li
          v-if="canManageConnectors"
          class="col nav-item text-center home-list-tab"
        >
          <span
            :class="{ 'active': tab === 'connectorsManager' }"
            class="nav-link"
            @click="tab = 'connectorsManager'"
          >
            Connecteurs
          </span>
        </li>
      </ul>
      <div class="home-list">
        <user-manager
          v-if="canManageUsers && tab === 'userManager'"
        />
        <app-settings-manager
          v-if="canManageSettings && tab === 'settingManager'"
          :sancare-only="false"
        />
        <app-settings-manager
          v-if="canManageSancareSettings && tab === 'sancareSettingManager'"
          :sancare-only="true"
        />
        <connectors-manager
          v-if="canManageConnectors && tab === 'connectorsManager'"
        />
      </div>
    </div>
  </div>
</template>
